export const TYPE = 'slate';

export const SLATE_UPDATED = 'SLATE_UPDATED';
export const updateSlate = ({ id, editor }) => ({
  type: SLATE_UPDATED,
  payload: { id, editor },
});
